import React from "react";
import { Link, withRouter } from "react-router-dom";

import Auth from "../../Auth";

const Header = ({ history }) => {
  return (
    <header>
      <nav className="navbar navbar-expand-md navbar-light fixed-top bg-light">
        <div className="container">
          <Link className="navbar-brand" to="/">
            Allegany Archive - Administration
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to="/exhibits" className="nav-link">
                  Manage Exhibits
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/users" className="nav-link">
                  User Access
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/tags" className="nav-link">
                  Tags
                </Link>
              </li>
              <li className="nav-item">
                <a
                  href="/"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    Auth.logout();
                    history.push('/login');
                  }}
                >
                  <i className="fa fa-sign-out" /> Logout
                </a>
              </li>
            </ul>
            <span className="pull-right" />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/pages/Main/Header.jsx